/* global google */

const MapTypes = {
  ROADMAP: 'roadmap',
  SATELLITE: 'satellite',
  HYBRID: 'hybrid',
  TERRAIN: 'terrain',
  LIGHT: 'light',
};

const rules = {};

rules[MapTypes.LIGHT] = [
  [
    {elementType: 'labels', stylers: [{visibility: 'on'}]},
    {elementType: 'labels.icon', stylers: [{visibility: 'on'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#546e7a'}]},
    {elementType: 'labels.text.stroke', stylers: [{color: '#ffffff'}]},
    {featureType: 'administrative', elementType: 'geometry', stylers: [{color: '#eceff1'}]},
    {featureType: 'landscape.natural', elementType: 'geometry', stylers: [{color: '#eceff1'}]},
    {featureType: 'poi', elementType: 'geometry', stylers: [{color: '#eceff1'}]},
    {featureType: 'poi', elementType: 'labels.text.fill', stylers: [{color: '#546e7a'}]},
    {featureType: 'poi', elementType: 'labels.text.stroke', stylers: [{color: '#ffffff'}]},
    {featureType: 'poi.park', elementType: 'geometry', stylers: [{color: '#c8e6c9'}]},
    {featureType: 'road', elementType: 'geometry', stylers: [{color: '#ffffff'}]},
    {featureType: 'road', elementType: 'labels', stylers: [{visibility: 'on'}]},
    {featureType: 'road', elementType: 'labels.text.fill', stylers: [{color: '#78909c'}]},
    {featureType: 'road.highway', elementType: 'geometry', stylers: [{color: '#cfd8dc'}]},
    {featureType: 'transit', elementType: 'labels', stylers: [{visibility: 'off'}]},
    {featureType: 'transit.line', elementType: 'geometry', stylers: [{color: '#cfd8dc'}]},
    {featureType: 'transit.station', elementType: 'geometry', stylers: [{color: '#e1e4e6'}]},
    {featureType: 'water', elementType: 'geometry', stylers: [{color: '#bbdefb'}]},
    {featureType: 'water', elementType: 'labels.text.fill', stylers: [{color: '#9e9e9e'}]},
  ],
  {name: 'Light'},
];

export const MapTypeRules = rules;

export default MapTypes;



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/MapTypes.js